import SetRoute from '../services/setRoute';

export const fetchImpactingPolicies = (
    fetch,
    param = '',
) => (
    {
        payload: {
            dataset: 'impacting_policies',
            action: 'get',
            route: SetRoute + `/api/v1/impacting_policies${param}`,
            data: {},
        },
        fetch,
    }
);

export default fetchImpactingPolicies;
